import { Injectable } from '@angular/core';

import { ApiClientService } from './util/api.client.service';

@Injectable()
export class AppService {
    constructor(private http: ApiClientService) {}

    getVersion() {
        // return this.http.get('/app/version', {secure: false});
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/app.service.ts